import { Action, createReducer, on } from '@ngrx/store';
import { IDistributionChart } from '../models/user-analytics.model';
import * as actions from '../actions';

export const getRequiredIncreaseInContributionsScatterChartKey = 'getRequiredIncreaseInContributionsScatterChart';
export interface RequiredIncreaseInContributionsScatterChartState {
  loadRequiredIncreaseInContributionsScatterChartResponse: IDistributionChart[];
  loadRequiredIncreaseInContributionsScatterChartResponseFailure: any;
  loaded: boolean;
}

export const initialState: RequiredIncreaseInContributionsScatterChartState = {
  loadRequiredIncreaseInContributionsScatterChartResponse: undefined,
  loadRequiredIncreaseInContributionsScatterChartResponseFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.loadRequiredIncreaseInContributionsScatterChart, (state, action) => ({
    ...state
  })),
  on(actions.loadRequiredIncreaseInContributionsScatterChartSuccess, (state, action) => ({
    ...state,
    loadRequiredIncreaseInContributionsScatterChartResponse: action.response,
    loaded: true
  })),
  on(actions.loadRequiredIncreaseInContributionsScatterChartFailure, (state, action) => ({
    ...state,
    loadRequiredIncreaseInContributionsScatterChartResponseFailure: action.error
  }))
);

export const getRequiredIncreaseInContributionsScatterChart = (state: RequiredIncreaseInContributionsScatterChartState) => {
  if (state && state.loadRequiredIncreaseInContributionsScatterChartResponse)
    return JSON.parse(JSON.stringify(state.loadRequiredIncreaseInContributionsScatterChartResponse));
  else return null;
};

export const getRequiredIncreaseInContributionsScatterChartIsLoaded = (state: RequiredIncreaseInContributionsScatterChartState) => {
  state.loaded;
};
